exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.addressViewCards .v-text-field__slot {\n    line-height: 22px !important;\n    padding-top: 6px !important;\n}\n", ""]);
